import { useEffect, useState } from 'react';

/** 'english' | 'hebrew' from localStorage.language, kept in sync with the TopBar toggle. */
export function useLanguage() {
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'english');

  useEffect(() => {
    const sync = () => setLanguage(localStorage.getItem('language') || 'english');
    window.addEventListener('storage', sync);
    window.addEventListener('languageChange', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('languageChange', sync);
    };
  }, []);

  useEffect(() => {
    document.documentElement.dir = language === 'hebrew' ? 'rtl' : 'ltr';
    document.documentElement.lang = language === 'hebrew' ? 'he' : 'en';
  }, [language]);

  return { language, direction: language === 'hebrew' ? 'rtl' : 'ltr', isHebrew: language === 'hebrew' };
}

/** t(key) over a { english, hebrew } strings object, falling back to English. */
export function makeT(strings, language) {
  return (key, vars) => {
    const dict = strings[language] || strings.english;
    let text = dict[key] ?? strings.english[key] ?? key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { text = text.replace(`{${k}}`, String(v)); });
    return text;
  };
}
